import script from "./ChatMessageFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageFilters.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageFilters.vue?vue&type=style&index=0&id=b47e95c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b47e95c4"]])

export default __exports__